<template>
<div class="ui centered grid" id="search_results">
    <div v-if="margin" class="two wide column"></div>
    <div  v-bind:class="{twelve:margin,sixteen:!margin,wide:true, column:true}" style="padding-left:0px">
    <!--<div class="sixteen wide column"  style="padding-left:0px">-->
        <div v-if="!norecords" class="ui top attached menu">
        <!--  <button   v-if="!dashboard_view"  class="compact ui button" v-on:click="dashboard_view=true">
            <i class="chart pie icon"></i>Dashboard View
          </button>-->
          <button   v-if="dashboard_view" class="compact ui button" v-on:click="dashboard_view=false">
            List view
          </button>
            <div class="right menu">
                <div style="padding-top:7px">
                    <div class="ui toggle checkbox checked" style="margin-right:1em;" id="tabs">
                        <input type="checkbox" name="tabs" v-model="tabbed" @change="tabsChange()">
                        <label style="padding-left:4em">Search Results by Inventories</label>
                    </div>
                  <!--  <div class="ui toggle checkbox checked" style="margin-right:1em;" id="pages">
                        <input type="checkbox" name="pages" disabled="disabled">
                        <label style="padding-left:4em">Pages</label>
                    </div>-->
                </div>
                <div class="ui compact selection dropdown disabled" style="border:0px;" id="orderBy">
                    <input type="hidden" name="orderByValue">
                    <i class="dropdown icon"></i>
                    <div class="text">Order by ID <i class="sort amount up icon"></i></div>
                    <div class="menu">
                        <div class="item" data-value="id-asc">Order by ID <i class="sort amount up icon"></i></div>
                        <div class="item" data-value="id-desct">Order by ID <i class="sort amount down icon"></i></div>
                        <div class="item" data-value="name-asc">Order by Name <i class="sort amount up icon"></i></div>
                        <div class="item" data-value="name-desct">Order by Name <i class="sort amount down icon"></i></div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div v-if="dashboard_view"  class="ui bottom active attached tab segment">
         <TheDashboardTab></TheDashboardTab>
        </div>
        <div v-if="!dashboard_view">
          <div v-if="!norecords && !tabbed">
            <div class="ui bottom active attached tab segment">
                <TheListView v-if="!loading" v-bind:itemList="itemList"></TheListView>
            </div>
            <div v-if="loading && !norecords" class="ui active bottom attached tab segment">
                <div class="ui active centered inline loader"></div><br>
                <div style='width:100%;text-align:center'>Loading...</div>
            </div>
          </div>
          <div v-if="!norecords && tabbed">
            <div class="ui tiny top attached tabular menu">
                <div class="left menu" v-bind:class="{hidden:!tabbed}">
                    <a v-for="item in inventories" :key="item.tab" v-on:click="activateTab(item.number)" class="item" data-tab="" v-bind:class="{'active':activeTab==item.number}">{{item.label}}</a>
                </div>
            </div>
            <div v-if="!loading && !norecords" class="ui bottom active attached tab segment">
                <TheListView v-if="!loading" v-bind:itemList="itemList"></TheListView>
            </div>
            <div v-if="loading && !norecords" class="ui active bottom attached tab segment">
                <div class="ui active centered inline loader"></div><br>
                <div style='width:100%;text-align:center'>Loading...</div>
            </div>
          </div>
        </div>
    </div>
    <div v-if="margin"  class="two wide column"></div>
    <div class="sixteen wide column ">
        <div  class="ui center aligned container">
            <div v-if="!loading && !norecords && tabbed">
                <div class="ui pagination menu">
                   <a v-for="page in (endPage - startPage+1)" :key="page+startPage-1" v-on:click="goToPage(page+startPage-1)" v-bind:class="{'item':true, 'active':((page+startPage-1) === inventories[activeTab].currentPage)}">{{page+startPage-1}}</a>
                </div>
            </div>
            <div v-if="!loading && !norecords && !tabbed">
                <div class="ui pagination menu">
                   <a v-for="page in (endPage - startPage+1)" :key="page+startPage-1" v-on:click="goToPage(page+startPage-1)" v-bind:class="{'item':true, 'active':((page+startPage-1) === currentPage)}">{{page+startPage-1}}</a>
                </div>
            </div>
        </div>
    </div>
     
</div>
</template>

<script>
  import TheListView from './TheListView.vue'
  import TheEasterEgg from './TheEasterEgg.vue'
  import TheDashboardTab from './TheDashboardTab.vue'
  //import TheSearchForm from 'TheSearchForm.vue'
  export default {
    name: 'search',
    props: ['query_props', 'margin'],
    components: {
      TheListView,
      TheEasterEgg,
      TheDashboardTab,
      // TheSearchForm,
    },
    data() {
      return {
        //    accordion_advanced:false,
        query: null,
        easteregg: false,
        eastereggname: "",
        tabbed: true,
        pages: true,
        norecords: false,
        orderBy: 'original_inventory_id',
        current_query: '',
        search_message: 'Found 0 item.',
        inventories: [],
        activeTab: 0,
        item: null,
        //   inventory: "1621Prague",
        itemList: null,

        itemsPerPage: 20,
        startPage: 0,
        endPage: 0,
        currentPage: 1,
        dashboard_view:false,
        loading: true,
      }
    },


    methods: {
      tabsChange: function() {
        var page_query = JSON.parse(JSON.stringify(this.query));
        page_query.tabbed = this.tabbed
        if (this.tabbed) {
          page_query.page = this.inventories[this.activeTab].currentPage;
        }
        else {
          page_query.page = 1;
        }
        if (this.$router.name == 'advancedsearch') {
          this.$router.push({ name: 'advancedsearch', query: page_query });
        }
        this.query = page_query;
      },

      goToPage: function(page) {
        var page_query = JSON.parse(JSON.stringify(this.query));
        page_query.page = page;
        if (this.$router.name == 'advancedsearch') {
          this.$router.push({ name: 'advancedsearch', query: page_query });
        }
        this.query = page_query;
        if (this.tabbed) {
          this.inventories[this.activeTab].currentPage = page;
        }
        this.inventories[this.activeTab].currentPage = page;

      },

      getSearchStatistic: function() {
        axios
          .get('/api/graph?name=inventory&search_query=text:' + this.current_query)
          .then(response => {
            this.search_message = "Found ";
            if (response.data.length == 0) {
              this.search_message += "0 item.";
            }
            for (var i in response.data) {
              this.search_message += response.data[i].value;
              if (response.data[i].value == 1) this.search_message += " item in " + response.data[i].label;
              else this.search_message += " items in " + response.data[i].label;
              if (parseInt(i) < response.data.length - 1)
                this.search_message += ", ";
            }

          })
      },

      loadData: function() {
        this.loading = true;
        var cursor = 0;
        var page = 1;
        var inventory = '';
        this.easteregg = false;
        // console.log(this.query);
        if (!jQuery.isEmptyObject(this.query)) {
          this.current_query = this.query;
          if (this.query.hasOwnProperty('page')) {
            page = parseInt(this.query.page);
            this.currentPage = page;
            if (this.tabbed) {
              cursor = 0;
            }
            else {
              cursor = this.itemsPerPage * (page - 1);
            }
          }

          if (this.query.hasOwnProperty('tabbed')) {
            this.tabbed = this.query.tabbed
            if (typeof this.tabbed == "string") {
              this.tabbed = (this.tabbed == 'true');
            }
          }
          if (this.query.hasOwnProperty('search')) {
            var search = this.checkEE(this.query.search);
          }
          var api_search_query = JSON.parse(JSON.stringify(this.query));
          api_search_query.cursor = cursor;
          api_search_query.items = this.itemsPerPage;

          axios
            .get('/api/search_v2?' + this.serializefromJSON(api_search_query))
            .then(response => {
              // this.getSearchStatistic();
              if (response.data.pagination.records == 0) {
                this.norecords = true;
                return;
              }
              else {
                this.norecords = false;
              }

              if (this.tabbed) {
                this.activeTab = 0;
                if (this.query.hasOwnProperty('activeTab')) {
                  this.activeTab = parseInt(this.query.activeTab);
                }
                if (this.inventories.length == 0) {
                  // this.inventories = [];
                  for (var i in response.data.pagination.inventories) {
                    this.inventories[parseInt(i)] = {
                      label: response.data.pagination.inventories[i].label,
                      name: response.data.pagination.inventories[i].name,
                      number: parseInt(i),
                      tab: 'tab' + i,
                      currentPage: 1
                    };
                    if (page > 1 && i == this.activeTab) {
                      this.inventories[parseInt(i)].currentPage = page;
                    }
                  }
                }

                api_search_query.inventory = this.inventories[this.activeTab].name;
                api_search_query.cursor = this.itemsPerPage * (this.inventories[this.activeTab].currentPage - 1)
                api_search_query.items = this.itemsPerPage

                axios
                  .get('/api/search_v2?' + this.serializefromJSON(api_search_query))
                  .then(response => {
                    this.itemList = response.data.data;
                    var noOfPages = Math.ceil(response.data.pagination.records / this.itemsPerPage);

                    if (noOfPages <= 10) {
                      this.startPage = 1;
                      this.endPage = noOfPages;
                    }
                    else if ((noOfPages - this.currentPage) < 10) {
                      this.startPage = noOfPages - 10;
                      this.endPage = noOfPages;
                    }
                    else if (this.currentPage > 5) {
                      this.startPage = this.currentPage - 4;
                      this.endPage = this.currentPage + 5;
                    }
                    else {
                      this.startPage = 1;
                      this.endPage = 10;
                    }
                    if (this.$route.path.startsWith('/advancedsearch')) {
                      setTimeout(function() {
                        var sr = document.getElementById('search_results');
                        sr.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                          inline: "nearest"
                        });
                      }, 100);
                    }

                  });

              }

              else {
                this.itemList = response.data.data;
                var noOfPages = Math.ceil(response.data.pagination.records / this.itemsPerPage);

                if (noOfPages <= 10) {
                  this.startPage = 1;
                  this.endPage = noOfPages;
                }
                else if ((noOfPages - this.currentPage) < 10) {
                  this.startPage = noOfPages - 10;
                  this.endPage = noOfPages;
                }
                else if (this.currentPage > 5) {
                  this.startPage = this.currentPage - 4;
                  this.endPage = this.currentPage + 5;
                }
                else {
                  this.startPage = 1;
                  this.endPage = 10;
                }

              }
              this.loading = false;
            });
        }
        else {
          this.loading = false;
          this.norecords = true;
        }
      },

      activateTab: function(tab) {
        var tab_query = JSON.parse(JSON.stringify(this.query));
        tab_query.activeTab = tab;
        tab_query.page = this.inventories[tab].currentPage;
        if (this.$router.name == 'advancedsearch') {
          this.$router.push({ name: 'advancedsearch', query: tab_query });
        }
        this.query = tab_query;
        this.itemList = null;
      },

      serializefromJSON: function(query) {
        var output = "";
        for (var key in query) {
          if (Array.isArray(query[key])) {
            for (var i in query[key]) {
              output += key + "=" + encodeURIComponent(query[key][i]) + "&";
            }
          }
          else {
            output += key + "=" + encodeURIComponent(query[key]) + "&";
          }
        }
        return output.slice(0, -1);
      },

      checkEE: function(search) {
        if (search.match(/mona lisa/gmi)) {
          this.easteregg = true;
          this.eastereggname = "mona_lisa"
          this.norecords = true;
          return
        }
        if (search.match(/elixir mladi/gmi)) {
          this.easteregg = true;
          this.eastereggname = "alessandro_scotta";
          this.norecords = true;
          return
        }
        if (search.match(/vanoce/gmi)) {
          this.easteregg = true;
          this.eastereggname = "kyrie";
          this.norecords = true;
          return
        }
      },

      scrollIntoSearchResults: function() {
        var sr = document.getElementById('search_results');
        sr.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }


      /*  setAccordtion: function() {
          if (Object.keys(this.$route.query).length == 1 && this.$route.query.hasOwnProperty('search')) {
            this.accordion_advanced=false;
          }
          else {
             this.accordion_advanced=true;
          }
        }*/


    },

    mounted() {
      //this.loadData(true);
    

    },

    watch: {
      $route(to, from) {
        //this.loadData();
      },
      query_props(to, from) {
        this.inventories = [];
        this.query = this.query_props;
      },
      query(to, from) {
        this.loadData();
      }
    }
  }
</script>

<style>
  .hidden {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/TheAdvancedSearch.vue